<template>
    <div id="home">
        <div class="header_nav">
            <div class="header">
                <div class="logoWord">华医云转诊后台管理系统</div>
                <!--<div class="curService">010-6215 0866</div>-->
            </div> 
        </div>
        <div class="homeBox">
            <div class="leftBox">
                <div class="person">
                    <img class="headImg" :src="headImg" alt="">
                    <p class="name"></p>
                </div>
                <ul class="navList">
                    <li :class="{'selected':nav=='hospManage'}" @click="select('hospManage')">医院管理</li>
                    <li :class="{'selected':nav=='caseManage'}" @click="select('caseManage')">病例管理</li>
                    <!-- <li :class="{'selected':nav=='regionData'}" @click="select('regionData')">地区监控</li> -->
                    <li :class="{'selected':nav=='/statistics'}" @click="select('statistics')">数据统计</li>
                    <li :class="{'selected':nav=='/logUser'}" @click="select('logUser')">日志管理</li>
                    <p class="exit" @click="exit()">退出登录</p>
                </ul>
            </div>
            <div class="content">
                <router-view></router-view>
            </div>
        </div>
        <footer-page></footer-page>
    </div>
</template>
<script>
import footerPage from '@/components/footer'
import headerImg from '@/assets/headImg.jpg'
export default {
    name:'home',
    components:{
        footerPage
    },
    data(){
        return{
            nav:'hospManage',
            identity:'',
            userInfo:{
                userName:'后台系统管理员'
            },
            headImg:headerImg
        }
    },
    mounted(){
        // this.userInfo=getStore('userInfo');
        // if(!this.userInfo){
        //     this.$router.push({name:'login'});
        //     return;
        // }
        // if(this.nav==hospManage){
        //     this.$router.push({name:'hospManage'});
        // }
    },
    methods:{
        select(num){
            this.nav = num;
            switch(num){
                case 'hospManage': this.$router.push({name:'hospManage'}); break;
                case 'statistics': this.$router.push({name:'statistics'}); break;
                case 'caseManage': this.$router.push({name:'caseManage'}); break;
                case 'regionData': this.$router.push({name:'regionData'}); break;
                case 'logUser': this.$router.push({name:'logUser'}); break;
            }
        },
        exit(){
            this.$common.removeStorage();
            this.$router.push({path:'/login'});
        }
    }
}
</script>
<style>
#home{
    width:100%;
    min-width: 1400px;
    box-sizing: border-box;
    background-color: #F9F9F9;
}
#home .header_nav{
    width:100%;
    text-align: left;
    overflow: hidden;
    box-sizing: border-box
}
#home .header_nav .header{
    width:100%;
    background: -webkit-gradient(linear, left top, right bottom, from(#0046a2), to(#2c74d2));
    background: linear-gradient(to bottom right, #0046a2, #2c74d2);
    padding:0px 50px 0 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
}
#home .logoWord{
    font-size: 26px;
    line-height: 80px;
    background-image: url('../assets/logo2.png');
    background-size: auto 60px;
    background-position: 0px 10px;
    background-repeat: no-repeat;
    padding-left:68px;
    color:#fff;
    box-sizing: border-box
}
#home .curService{
    display: inline-block;
    background-image: url('../assets/tel.png');
    background-repeat: no-repeat;
    padding-left:50px;
    background-size: 30px 30px;
    background-position: 20px 26px;
    line-height: 80px;
    color:#fff;
}
#home .homeBox{
    width:100%;
    height:100%;
    overflow: hidden;
    position: relative;
}
#home .leftBox{
    float: left;
    width:200px;
    background-color: #333333;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
}
#home .person{
    width:100%;
    text-align: center;
    padding: 20px 0;
    box-sizing: border-box;
}
#home .person .headImg{
    width:120px;
    height:120px;
    border-radius: 50%;
}
#home .person .name{
    color:#fff;
    line-height: 50px;
    font-size: 16px;
}
#home .leftBox .exit{
    color:#fff;
    margin-top:50px;
    cursor: pointer;
}
#home .navList{
    width:100%;
    list-style: none;
    font-size: 16px;
    color:#fff;
}
#home .navList li{
    line-height: 50px;
    padding:0 20px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
}
#home .content{
    margin-left:200px;
    min-height:1000px;
    box-sizing: border-box;
}
#home .selected{
    background-color: #014093;
}
</style>





// WEBPACK FOOTER //
// src/page/home.vue